import { Editor, Transforms, Element as SlateElement, Node } from 'slate'

type ListType = 'bulleted-list' | 'numbered-list'
export type BlockType =
  | 'alpha-list'
  | 'bulleted-list'
  | 'numbered-list'
  | 'list-item'
  | 'paragraph'
  | 'heading-one'
  | 'heading-two'

const isListType = (type: string): type is ListType => {
  return (
    type === 'bulleted-list' ||
    type === 'numbered-list' ||
    type === 'alpha-list'
  )
}

const isListActive = (editor: Editor, format: ListType): boolean => {
  const { selection } = editor
  if (!selection) return false

  const [match] = Array.from(
    Editor.nodes(editor, {
      at: Editor.unhangRange(editor, selection),
      match: (n: Node & { type: string }) =>
        !Editor.isEditor(n) && SlateElement.isElement(n) && n.type === format,
    })
  )

  return !!match
}

export const toggleList = (editor: Editor, format: ListType): void => {
  const isActive = isListActive(editor, format)

  if (isActive) {
    Transforms.unwrapNodes(editor, {
      match: (n: Node & { type: string }) =>
        !Editor.isEditor(n) && SlateElement.isElement(n) && isListType(n.type),
      split: true,
    })

    Transforms.setNodes(editor, { type: 'paragraph' } as any)
  } else {
    const otherListType =
      format === 'bulleted-list' ? 'numbered-list' : 'bulleted-list'
    const isInOtherList = isListActive(editor, otherListType)

    if (isInOtherList) {
      Transforms.setNodes(editor, { type: format } as any, {
        match: (n: Node & { type: string }) =>
          !Editor.isEditor(n) &&
          SlateElement.isElement(n) &&
          isListType(n.type),
      })
    } else {
      Transforms.setNodes(editor, { type: 'list-item' } as any)

      Transforms.wrapNodes(editor, { type: format, children: [] } as any, {
        match: (n: Node & { type: string }) =>
          !Editor.isEditor(n) &&
          SlateElement.isElement(n) &&
          n.type === 'list-item',
      })
    }
  }
}

export const isBlockActive = (editor: Editor, format: BlockType): boolean => {
  const { selection } = editor
  if (!selection) return false

  const [match] = Array.from(
    Editor.nodes(editor, {
      at: Editor.unhangRange(editor, selection),
      match: (n: Node & { type: string }) =>
        !Editor.isEditor(n) && SlateElement.isElement(n) && n.type === format,
    })
  )

  return !!match
}

export const toggleBlock = (editor: Editor, format: BlockType): void => {
  const isActive = isBlockActive(editor, format)
  const isList = isListType(format)

  if (isList) {
    toggleList(editor, format)
    return
  }

  Transforms.setNodes(
    editor,
    { type: isActive ? 'paragraph' : format } as any,
    { match: (n: any) => Editor.isBlock(editor, n) }
  )
}
